import "../../styles/HomePractice.css";
import { useNavigate } from "react-router-dom";

const practiceAreas = [
    {
        title: "Family Law",
        image:
            "/Home/p1.png",
    },
    {
        title: "Corporate",
        image:
            "/Home/p2.png",
    },
    {
        title: "Property",
        image:
            "/Home/p3.png",
    },
    {
        title: "Criminal",
        image:
            "/Home/p4.png",
    },
    {
        title: "Tax Law",
        image:
            "/Home/p5.png",
    },
];



export default function HomePractice() {
    const navigate = useNavigate();

    return (
        <section className="practice-section">
            <div className="practice-header">
                <div>
                    <h2 className="practice-title">Popular <span style={{ color: "#d6b87c" }}>Practice Areas</span></h2>
                    <p className="practice-subtitle" id="practice-subtitle">Explore specialised legal fields.</p>
                </div>
                <span
                    className="view-all"
                    onClick={() => navigate("/search")}
                >
                    View all areas →
                </span>
            </div>

            <div className="practice-slider">
                <div className="practice-track">
                    {[...practiceAreas, ...practiceAreas].map((item, index) => (
                        <div className="practice-card" key={index}>
                            <div className="practice-image">
                                <img src={item.image} alt={item.title} />
                            </div>
                            <h4>{item.title}</h4>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
